import React from 'react';
import ListSearch from '../list/ListSearch';

const RepairSearch = props => {

  const renderSuggestion = suggestion => {
    const { itemid, Name, Status, Operations, VIN } = suggestion;

    const style = {
      fontSize: '12px',
    };

    return (
      <div className="repair-suggestion">
        <div><b>{Name}</b> ({itemid})</div>
        {Status ? (
          <div style={style} className={Status.replace(/\s/g, '')}>{Status}</div>
        ) : null}
        {VIN ? (
          <div style={style}>VIN: {VIN}</div>
        ) : null}
        { Operations ? (
          <div style={style}>Operations: {Operations}</div>
        ) : null}
      </div>
    );
  };

  return (
    <ListSearch
      {...props}
      renderSuggestion={renderSuggestion}
    />
  );
};

export default RepairSearch;
